import {createSvgIcon} from '../create-svg-icon';

export const FirstPageIcon = createSvgIcon(
  <path d="M18.41 16.59 13.82 12l4.59-4.59L17 6l-6 6 6 6 1.41-1.41zM6 6h2v12H6V6z" />
, 'FirstPageOutlined');
